import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    methods: {
        //获取列表
        getList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize
            };
            this.loading = true;
            $http.get("api/Option/GetOptionByPage", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.lists = Data;
                    this.totalSize = Cnt;
                });
            });
        },
        // GET /api/Option/OptionDisable
        OptionDisable(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            $http.get("api/Option/OptionDisable", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.getList()
                });
            });
        },
        //GET /api/Option/OptionEnable
        OptionEnable(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            $http.get("api/Option/OptionEnable", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.getList()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/checkList/services.js